module.exports = __webpack_public_path__ + "static/media/admin-printer.7ad65d71.svg";